import { useCallback, useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';
/**
 * Хук для подключения к WebSocket Gateway игр
 *
 * Предоставляет real-time обновления о бронировании и изменении игр
 */
export var useGameWebSocket = function (_a) {
    var url = _a.url, token = _a.token, _b = _a.autoConnect, autoConnect = _b === void 0 ? true : _b;
    var socketRef = useRef(null);
    var _c = useState(false), connected = _c[0], setConnected = _c[1];
    /** Подключение к серверу */
    var connect = useCallback(function () {
        var _a;
        if ((_a = socketRef.current) === null || _a === void 0 ? void 0 : _a.connected) {
            return;
        }
        socketRef.current = io("".concat(url, "/games"), {
            auth: { token: token },
            transports: ['websocket', 'polling'],
            reconnection: true,
            reconnectionDelay: 1000,
            reconnectionAttempts: 5,
        });
        socketRef.current.on('connect', function () {
            setConnected(true);
        });
        socketRef.current.on('disconnect', function () {
            setConnected(false);
        });
        socketRef.current.on('connect_error', function (error) {
            console.error('[WebSocket] Connection error:', error.message);
        });
    }, [url, token]);
    /** Отключение от сервера */
    var disconnect = useCallback(function () {
        if (socketRef.current) {
            socketRef.current.disconnect();
            socketRef.current = null;
            setConnected(false);
        }
    }, []);
    /** Подписка на события площадки */
    var subscribeToPlace = useCallback(function (placeId) {
        var _a;
        if ((_a = socketRef.current) === null || _a === void 0 ? void 0 : _a.connected) {
            socketRef.current.emit('subscribe:place', { placeId: placeId });
        }
        else {
            console.warn('[WebSocket] Not connected, cannot subscribe');
        }
    }, []);
    /** Отписка от событий площадки */
    var unsubscribeFromPlace = useCallback(function (placeId) {
        var _a;
        if ((_a = socketRef.current) === null || _a === void 0 ? void 0 : _a.connected) {
            socketRef.current.emit('unsubscribe:place', { placeId: placeId });
        }
    }, []);
    /** Подписка на событие */
    var onEvent = useCallback(function (event, callback) {
        if (socketRef.current) {
            socketRef.current.on(event, callback);
        }
    }, []);
    /** Отписка от события */
    var offEvent = useCallback(function (event, callback) {
        if (socketRef.current) {
            socketRef.current.off(event, callback);
        }
    }, []);
    /** Автоматическое подключение при монтировании */
    useEffect(function () {
        if (autoConnect) {
            connect();
        }
        return function () {
            disconnect();
        };
    }, [autoConnect, connect, disconnect]);
    return {
        connected: connected,
        connect: connect,
        disconnect: disconnect,
        subscribeToPlace: subscribeToPlace,
        unsubscribeFromPlace: unsubscribeFromPlace,
        onEvent: onEvent,
        offEvent: offEvent,
    };
};
